import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
type HeartConfig = {
  className: string;
  opacity: number;
  delay: number;
  duration: number;
  filled?: boolean;
  drift: number;
  tilt: number;
};
const hearts: HeartConfig[] = [{
  className: 'left-[2%] top-[8%] size-[clamp(34px,3.6vw,68px)]',
  opacity: 0.22,
  delay: 0,
  duration: 6.2,
  drift: 14,
  tilt: 10,
  filled: true
}, {
  className: 'left-[13%] top-[62%] size-[clamp(24px,2.6vw,48px)]',
  opacity: 0.16,
  delay: 0.6,
  duration: 5.4,
  drift: -12,
  tilt: -12
}, {
  className: 'left-[31%] top-[3%] size-[clamp(20px,2.2vw,40px)]',
  opacity: 0.14,
  delay: 1.2,
  duration: 5.8,
  drift: 10,
  tilt: 8
}, {
  className: 'right-[3%] top-[10%] size-[clamp(32px,3.4vw,64px)]',
  opacity: 0.2,
  delay: 0.3,
  duration: 6.4,
  drift: -14,
  tilt: -10,
  filled: true
}, {
  className: 'right-[15%] bottom-[8%] size-[clamp(26px,2.8vw,52px)]',
  opacity: 0.15,
  delay: 1.6,
  duration: 5.6,
  drift: 12,
  tilt: 12
}, {
  className: 'right-[36%] top-[2%] size-[clamp(18px,2vw,36px)]',
  opacity: 0.12,
  delay: 2,
  duration: 5.1,
  drift: -9,
  tilt: -8,
  filled: true
}, {
  className: 'left-[46%] bottom-[4%] size-[clamp(22px,2.4vw,44px)]',
  opacity: 0.13,
  delay: 1,
  duration: 6,
  drift: 11,
  tilt: 9
}];

/** Ambient "brands need love" motif. Purely decorative. */
export function FloatingHearts({
  colorClassName = 'text-[var(--brand-green-lighter)]'
}: {
  colorClassName?: string;
}) {
  const reduceMotion = useReducedMotion();
  return <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true" data-id="element-4" data-mp="zvm28zj3m06f">
      {hearts.map((heart, index) => <motion.div key={index} className={`absolute ${colorClassName} ${heart.className}`} initial={{
      opacity: heart.opacity,
      rotate: heart.tilt
    }} animate={reduceMotion ? {
      opacity: heart.opacity,
      rotate: heart.tilt
    } : {
      y: [14, -16, -48, 14],
      x: [0, heart.drift, -heart.drift, 0],
      rotate: [heart.tilt, -heart.tilt, heart.tilt * 0.7, heart.tilt],
      scale: [1, 1.12, 0.95, 1],
      opacity: heart.opacity
    }} transition={reduceMotion ? {
      duration: 0
    } : {
      duration: Math.max(4, heart.duration),
      delay: heart.delay * 0.3,
      repeat: Infinity,
      ease: 'easeInOut',
      times: [0, 0.3, 0.7, 1]
    }} data-id="element-5" data-mp="vvjwae6byklc" data-mpi={index}>
          <HeartIcon className="h-full w-full" fill={heart.filled ? 'currentColor' : 'none'} strokeWidth={heart.filled ? 1.5 : 1.8} data-id="element-6" data-mp="3e3vcba81x1fu" />
        </motion.div>)}
    </div>;
}